import Layout from "../../components/layout";
import Seo from "../../components/seo";
import { useRouter } from "next/router";
import ReactMarkdown from "react-markdown";
import {
  category_getStaticProps,
  collection_getStaticPaths,
  getUrlParamsObject,
} from "../../lib/statics";
import { fetchAPI } from "../../lib/api";
import Link from "next/link";
import { BreadcrumbArrow } from "../../components/breadcrumb-arrow";

import "../../components/markdown-to-html.module.css";
import MarkdownToHtml from "../../components/markdown-to-html";

const Legal = ({ categories, legal, legals }) => {
  const router = useRouter();
  const slugs = router.query.slug || [];

  const seo = {
    metaTitle: `Legal - ${legal?.attributes?.title}`,
    metaDescription: `Legal ${legal?.attributes?.title}`,
  };

  return (
    <Layout categories={categories}>
      <Seo seo={seo} />
      <div className={`hidden lg:block border-t border-b pt-2 pb-2 bg-white`}>
        <div className="container mx-auto pl-1 pr-1">
          <ul className={`flex flex-row items-center space-x-4`}>
            <li>
              <Link href={`/`}>
                <a className={`hover:underline`}>Home</a>
              </Link>
            </li>
            <li>
              <span className={`flex flex-row items-center space-x-4`}>
                <BreadcrumbArrow />
                <span className={``}>Legal</span>
              </span>
            </li>
            <li>
              <span className={`flex flex-row items-center space-x-4`}>
                <BreadcrumbArrow />
                <span className={``}>{legal?.attributes?.title}</span>
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div className={`bg-[#F5F5F5] py-8`}>
        <div className="container mx-auto pl-1 pr-1">
          <div className={`grid grid-cols-5 gap-8`}>
            <aside className={`hidden lg:block `}>
              <ul className={`flex flex-col`}>
                <li className={`border-b pb-5`}>
                  <span className={`flex items-center min-h-[40px]`}>
                    <h2
                      className={`font-display font-bold text-[24px] uppercase leading-none`}
                    >
                      Legal
                    </h2>
                  </span>
                </li>
                {legals.map((legal, key) => {
                  return (
                    <li key={key} className={`leading-none text-[18px] mt-5`}>
                      <Link href={`/legal/${legal?.attributes?.slug}`}>
                        <a className={`hover:underline font-display`}>
                          {legal?.attributes?.title}
                        </a>
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </aside>
            <main className={`col-span-4`}>
              <h1
                className={`font-display font-bold text-[40px] uppercase leading-none`}
              >
                {legal?.attributes?.title}
              </h1>

              {legal?.attributes?.body && (
                <div className={`mt-4`}>
                  <MarkdownToHtml markdown={legal?.attributes?.body} />
                </div>
              )}
            </main>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export async function getStaticProps({ params }) {
  const ret = await category_getStaticProps({ params });
  const [legalsRes, legalRes] = await Promise.all([
    fetchAPI("/legals", getUrlParamsObject()),
    fetchAPI("/legals", {
      filters: { slug: params.slug[params.slug.length - 1] },
      ...getUrlParamsObject(),
    }),
  ]);
  ret.props.legals = legalsRes.data;
  ret.props.legal = legalRes.data[0];

  return ret;
}

export async function getStaticPaths() {
  return await collection_getStaticPaths("legals");
}

export default Legal;
